import LoadMoreData from './load-more-data';

export default LoadMoreData;